import './GenericDataTable.scss';
import { DataTable } from 'primereact/datatable'

function GenericDataTable({children, padding , spacedRows, customClasses = ``,...restProps}) {
  let mutatedClassName = customClasses

  if (spacedRows) {
    mutatedClassName += ' Spaced '
  }
  if(padding){
    mutatedClassName +="Padding"
  }

  return (
    <DataTable responsiveLayout='scroll' className={`GenericDataTable ${mutatedClassName}`} {...restProps} >
      {children}
    </DataTable>
  )
}

GenericDataTable.defaultProps = {
  value: [],
  spacedRows: false,
  padding:false
}

export default GenericDataTable